import React, { useEffect, useState } from 'react';
import { Accordion } from '../../../../CommonComponents/OPL/Accordion/Accordion/Accordion';
import { AccordionButton } from '../../../../CommonComponents/OPL/Accordion/AccordionButton/AccordionButton';
import { AccordionPanel } from '../../../../CommonComponents/OPL/Accordion/AccordionPanel/AccordionPanel';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Topic } from '../../../MoneyGuideProTypes';
import { HtmlTable } from '../../../../CommonComponents/OPL/HtmlTable/HtmlTable';

interface Props {
  description: string;
  topics: Topic[];
  selectedIndex: number;
}

export const TabAccordion: React.FC<Props> = ({ description, topics, selectedIndex }) => {
  const buttonId = `button-${description}`;
  const panelId = `panel-${description}`;
  const [isActive, setIsActive] = useState(true);

  const value = selectedIndex === 0 ? 'current' : 'recommended';
  const subValue = selectedIndex === 0 ? '' : 'changes';

  useEffect(() => {
    setIsActive(true);
  }, [selectedIndex]);

  return (
    <Accordion key={description} isActive={isActive} borderRadius="none">
      <AccordionButton
        id={buttonId}
        panelId={panelId}
        isActive={isActive}
        onClick={() => {
          setIsActive(!isActive);
        }}
      >
        {description}
      </AccordionButton>

      <AccordionPanel id={panelId} buttonId={buttonId} isActive={isActive}>
        <HtmlTable variant="embedded" columnSpacing="small">
          <table style={{ tableLayout: 'fixed', width: '100%' }}>
            <colgroup>
              <col width="50%" />
              <col width="50%" />
            </colgroup>
            <tbody>
              {topics.map(topic => (
                <React.Fragment key={topic.description}>
                  <tr>
                    <td colSpan={topic[value] || topic[subValue] ? 1 : 2}>
                      <Text fontSize="h6" textAlign="left" fontWeight={600}>
                        {topic.description}
                      </Text>
                    </td>
                    {(topic[value] || topic[subValue]) && (
                      <td>
                        <Text fontSize="h6" textAlign="right" fontWeight={600}>
                          {topic[value]}
                        </Text>
                        {topic[subValue] && (
                          <Text
                            fontSize="body"
                            color="neutral.400"
                            textAlign="right"
                            fontWeight={600}
                          >
                            ({topic[subValue]})
                          </Text>
                        )}
                      </td>
                    )}
                  </tr>
                  {topic.items.map(item => (
                    <React.Fragment key={item.description}>
                      <tr>
                        <td colSpan={item[value] || item[subValue] ? 1 : 2}>
                          <Text
                            fontSize="h6"
                            textAlign="left"
                            fontWeight={item.details?.length ? 600 : 400}
                          >
                            {item.description}
                          </Text>
                        </td>
                        {(item[value] || item[subValue]) && (
                          <td>
                            <Text
                              fontSize="h6"
                              textAlign="right"
                              fontWeight={item.details?.length ? 600 : 400}
                            >
                              {item[value]}
                            </Text>
                            {item[subValue] && (
                              <Text
                                fontSize="body"
                                color="neutral.400"
                                textAlign="right"
                                fontWeight={item.details?.length ? 600 : 400}
                              >
                                ({item[subValue]})
                              </Text>
                            )}
                          </td>
                        )}
                      </tr>
                      {item.details?.map(data => (
                        <React.Fragment key={data.description}>
                          <tr>
                            <td colSpan={data[value] || data[subValue] ? 1 : 2}>
                              <Text fontSize="h6" textAlign="left" pl="12">
                                {data.description}
                              </Text>
                            </td>
                            {(data[value] || data[subValue]) && (
                              <td>
                                <Text fontSize="h6" textAlign="right">
                                  {data[value]}
                                </Text>
                                {data[subValue] && (
                                  <Text fontSize="body" color="neutral.400" textAlign="right">
                                    ({data[subValue]})
                                  </Text>
                                )}
                              </td>
                            )}
                          </tr>
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </HtmlTable>
      </AccordionPanel>
    </Accordion>
  );
};
